import { DatePipe } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import moment from 'moment';
import {
  Categories,
  LoginModel,
  MainDepartment,
  Stores
} from 'src/app/Models/ApplicationModels';
import { AdminBreadcrumbsService } from 'src/app/rcs/admin-module/admin-services/admin-breadcrumbs.service';
import { MasterDataSeriveService } from 'src/app/Services/master-data-serive.service';
import { ProductionCycle } from 'src/app/rcs/admin-module/company-config/WeekColors/models/week-color.model';
import { WeekColorService } from 'src/app/rcs/admin-module/company-config/WeekColors/services/week-color.service';
import { OverrideStatus } from 'src/app/enum/enum';
import { ExportExcelService } from 'src/app/Services/export-excel.service';
import { ReportsV3ApiService } from '../services/reports-v3-api.service';

@Component({
  selector: 'app-sale-per-producer-reportv3',
  templateUrl: './sale-per-producer-reportv3.component.html',
  styleUrls: ['./sale-per-producer-reportv3.component.css']
})
export class SalePerProducerReportV3Component {
  @ViewChild('dateRange') dateRange!: ElementRef<HTMLElement>;
  userInfo: LoginModel = new LoginModel();
  startDate: any;
  endDate: any;
  storeId: string = '0';

  salesGraph: any;
  stores: Array<Stores> = [];
  deptName: string = 'All departments';
  categoryName: string = 'All categories';
  storeName: string = 'All stores';
  deptNames: Array<string> = [];
  deptIDs: Array<string> = [];
  deptId: string = '0';
  storeNames: Array<string> = [];
  storeIds: Array<string> = [];

  mainDepartmentList: Array<MainDepartment> = [];
  categorieslist: Array<Categories> = [];
  disableCategory: boolean = true;
  sellThroughData: any;
  sellThroughDeptData: any;
  sellThroughDeptTableData: any;
  modalStoreName: string = '';
  modalUserName: string = '';
  noDataFound: boolean = false;
  usersArray: any;
  chartUserName: string = 'Over All';
  chartStoreName: string = '';
  chartLabels: Array<string> = [];
  sellThroughChart: { date: string; sellThroughPercentage: number }[] = [];
  weekColor: string = 'All Week Colors';
  weekColorsList: Array<ProductionCycle> = [];
  weekColorSchedule: Array<ProductionCycle> = [];
  productionCycleId: number = 0;
  weekColorHeaderSelected: boolean = false;
  departmentCategoriesMap: Map<number, Categories[]> = new Map();
  salePerProducerReportData: any[] = [];
  groupedSalePerProducerReportData: { storeName: string; items: any[] }[] = [];
  showWeekColor: boolean = true;

  storeID: number = 0;
  userId: number = 0;
  categoryId: number = 0;
  isLoading: boolean = false;
  reportHasRun: boolean = false;
  headerCheckboxSelected: boolean = false;
  headerDeptCheckboxSelected: boolean = false;
  producersColumns = [
    { columnName: 'Quantity Sold' },
    { columnName: 'Sales Amount' },
    { columnName: 'Total Items Sold' },
    { columnName: 'Total Sales Amount' },
    { columnName: 'Total Production Value' },
    { columnName: 'Quantity Produced' }
  ];
  reportHead: string = 'ALL STORES SELECTED | ALL DEPARTMENTS / all categories';

  constructor(
    private masterService: MasterDataSeriveService,
    private adminBreadcrumbs: AdminBreadcrumbsService,
    private datepipe: DatePipe,
    private reportsV3Service: ReportsV3ApiService,
    private weekColorService: WeekColorService,
    private exportExcelService: ExportExcelService
  ) {}

  ngOnInit(): void {
    this.adminBreadcrumbs.updateBreadcrumbs([
      { crumbName: 'Reports', link: 'demo' },
      {
        crumbName: 'Sales Productivity Report',
        link: '/admin/home/v3/sale-per-producer-report'
      }
    ]);
    this.userInfo = JSON.parse(localStorage.getItem('user')!);

    const productionScheduleType = (this.userInfo as any)?.productionScheduleType
      ?.toString()
      ?.trim()
      ?.toLowerCase();
    this.showWeekColor = productionScheduleType !== 'datespecific';
    this.getStores();
    if (this.showWeekColor) {
      this.getWeekColors();
    } else {
      this.productionCycleId = 0;
      this.weekColor = 'All Week Colors';
    }
    this.getMainDepartments();
    this.startDate = moment().format('MM-DD-YYYY');
    this.endDate = moment().format('MM-DD-YYYY');
  }

  getStores() {
    let user = this.masterService.getUserDetailsFromStorage();
    this.masterService.getallstores(user.companyID).subscribe((res) => {
      if (Array.isArray(res)) {
        for (let item of res) {
          this.stores.push(item);
        }
      }
      this.storeID = this.stores[0]?.storeId;
      this.chartStoreName = this.stores[0]?.storeName;
    });
  }

  getMainDepartments() {
    this.masterService.getDepartmentsProduction(false, 0).subscribe(
      (Response: any) => {
        this.mainDepartmentList = Response as MainDepartment[];
        this.mainDepartmentList.forEach((d) => (d.isSelected = false));
      },
      (err) => {}
    );
  }

  getWeekColors() {
    this.weekColorService.getProductionCycles(this.userInfo.companyID).subscribe((res) => {
      this.weekColorsList = res as ProductionCycle[];
      this.weekColorsList = this.weekColorsList.filter(
        (item) => item.status === OverrideStatus.Active
      );
    });
  }

  public options: any = {
    locale: {
      format: 'MM/DD/YYYY',
      separator: ' - ',
      applyLabel: 'Apply',
      cancelLabel: 'Cancel'
    },
    alwaysShowCalendars: true,
    showDropdowns: false,
    showCustomRangeLabel: true,
    maxDate: new Date(),
    ranges: {
      Today: [moment(), moment()],
      Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
      'This Week': [moment().startOf('week'), moment()],
      'Last Week': [
        moment().subtract(1, 'week').startOf('week'),
        moment().subtract(1, 'week').endOf('week')
      ],
      'This Month': [moment().startOf('month'), moment().endOf('month')],
      'Last Month': [
        moment().subtract(1, 'month').startOf('month'),
        moment().subtract(1, 'month').endOf('month')
      ]
    },
    opens: 'left'
  };

  public selectedDate(value: any) {
    this.endDate = value.end._d;
    this.startDate = value.start._d;
  }

  openCalender() {
    if (this.dateRange) {
      this.dateRange.nativeElement.click();
    }
  }

  toggleAllCheckboxes() {
    this.headerCheckboxSelected = !this.headerCheckboxSelected;

    if (this.headerCheckboxSelected) {
      this.storeIds = this.stores.map((str) => str.storeId.toString());
    } else {
      this.storeIds = [];
    }
    if (this.storeIds.length) {
      this.storeId = this.storeIds.join(', ');
    } else {
      this.storeName = 'All stores';
      this.storeId = '0';
    }
  }

  toggleAllDepartments() {
    this.headerDeptCheckboxSelected = !this.headerDeptCheckboxSelected;

    if (this.headerDeptCheckboxSelected) {
      this.deptNames = this.mainDepartmentList.map((d) => d.departmentDescr);
      this.deptIDs = this.mainDepartmentList.map((d) => d.departmentId.toString());
      this.mainDepartmentList.forEach((d) => (d.isSelected = true));
      this.deptId = '0';
    } else {
      this.deptNames = [];
      this.deptIDs = [];
      this.mainDepartmentList.forEach((d) => (d.isSelected = false));
      this.deptId = '0';
    }

    if (this.deptIDs.length == this.mainDepartmentList.length) {
      this.deptId = '0';
      this.deptName = 'All departments';
    }

    this.departmentCategoriesMap.clear();
    this.rebuildCategoriesList();
  }

  selectAllDepartments() {
    this.deptName = 'All departments';
    this.deptNames = [];
    this.deptIDs = [];
    this.deptId = '0';
    this.disableCategory = true;

    this.departmentCategoriesMap.clear();
    this.categorieslist = [];
    this.categoryName = 'All categories';
    this.categoryId = 0;
  }

  selectAllcategories() {
    if (this.categorieslist.length) {
      let index = this.reportHead.indexOf('/');
      if (index !== -1) {
        this.reportHead = this.reportHead.substring(0, index);
      }
    }
    this.categoryName = 'All categories';
    this.categoryId = 0;
  }

  setOverAllOption() {
    this.chartUserName = 'Over All';
    this.userId = 0;
  }

  setFilterNames(filterObj: any, option: number) {
    if (option === 1) {
      const nameIndex = this.deptNames.findIndex(
        (item) => item === filterObj.departmentDescr
      );
      this.reportHead = '';
      let isAdding = false;

      if (nameIndex !== -1) {
        this.deptNames.splice(nameIndex, 1);
        filterObj.isSelected = false;
        this.reportHead = this.deptNames[nameIndex - 1];
        isAdding = false;
      } else {
        this.deptNames.push(filterObj.departmentDescr);
        filterObj.isSelected = true;
        this.reportHead = filterObj.departmentDescr;
        isAdding = true;
      }

      if (this.deptNames.length > 1) {
        this.deptName =
          this.deptNames.slice(0, 1) + ' +' + `${this.deptNames.length - 1}`;
      } else {
        this.deptName = this.deptNames.join(', ');
      }

      const iDIndex = this.deptIDs.indexOf(filterObj.departmentId.toString());

      if (iDIndex !== -1) {
        this.deptIDs.splice(iDIndex, 1);
      } else {
        this.deptIDs.push(filterObj.departmentId.toString());
      }

      if (this.deptIDs.length) {
        this.deptId = this.deptIDs.join(',');
      } else {
        this.deptName = 'All departments';
        this.deptId = '0';
        this.disableCategory = true;
      }
      this.disableCategory = this.deptId === '0';
      this.headerDeptCheckboxSelected =
        this.deptIDs.length === this.mainDepartmentList.length;

      this.updateCategoriesList(filterObj.departmentId, isAdding);
    }
    if (option === 2) {
      const nameIndex = this.storeNames.findIndex(
        (item) => item === filterObj.storeName
      );

      if (nameIndex !== -1) {
        this.storeNames.splice(nameIndex, 1);
      } else {
        this.storeNames.push(filterObj.storeName);
      }

      if (this.storeNames.length > 1) {
        this.storeName =
          this.storeNames.slice(0, 1) + ' +' + `${this.storeNames.length - 1}`;
      } else {
        this.storeName = this.storeNames.join(', ');
      }

      const iDIndex = this.storeIds.indexOf(filterObj.storeId.toString());

      if (iDIndex !== -1) {
        this.storeIds.splice(iDIndex, 1);
      } else {
        this.storeIds.push(filterObj.storeId.toString());
      }

      if (this.storeIds.length) {
        this.storeId = this.storeIds.join(', ');
      } else {
        this.storeName = 'All stores';
        this.storeId = '0';
      }
      this.disableCategory = this.deptId === '0';
    }
    if (option === 3) {
      this.categoryName = filterObj.categoryName;
      this.categoryId = filterObj.categoryId;
    }
    if (option == 5) {
      this.weekColor = filterObj.displayName;
      this.productionCycleId = filterObj.productionCycleId;
    }
  }

  rebuildCategoriesList() {
    const categoryMap = new Map<number, Categories>();
    this.departmentCategoriesMap.forEach((categories) => {
      if (Array.isArray(categories)) {
        categories.forEach((cat) => {
          if (cat && cat.categoryId !== undefined) {
            categoryMap.set(cat.categoryId, cat);
          }
        });
      }
    });

    this.categorieslist = Array.from(categoryMap.values());
    this.categoryName = 'All categories';
    this.categoryId = 0;
  }

  updateCategoriesList(deptId?: number, isAdding?: boolean) {
    if (this.deptIDs.length === 0) {
      this.departmentCategoriesMap.clear();
      this.categorieslist = [];
      this.categoryName = 'All categories';
      this.categoryId = 0;
      return;
    }

    if (isAdding && deptId !== undefined) {
      this.masterService
        .getCategoriesByDeptUserID(deptId, this.userInfo.userId, false, 0)
        .subscribe((res: any) => {
          this.departmentCategoriesMap.set(deptId, res as Categories[]);
          this.rebuildCategoriesList();
        });
      return;
    }

    if (!isAdding && deptId !== undefined) {
      this.departmentCategoriesMap.delete(deptId);
      this.rebuildCategoriesList();
      return;
    }

    this.rebuildCategoriesList();
  }

  runReport() {
    this.reportHasRun = true;
    this.getSalePerProducerReport();
  }

  getSalePerProducerReport() {
    this.isLoading = true;
    this.reportHasRun = true;
    const formattedStartDate = this.datepipe.transform(
      this.startDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    const formattedEndDate = this.datepipe.transform(
      this.endDate,
      'yyyy-MM-dd HH:mm:ss'
    );

    this.reportsV3Service.getSalePerProducerReportV3(
      this.userInfo.companyID,
      this.storeIds.length > 0 ? this.storeIds.join(',') : '0',
      this.deptIDs.length > 0 ? this.deptIDs.join(',') : '0',
      this.categoryId > 0 ? this.categoryId.toString() : '0',
      this.userId ?? 0,
      formattedStartDate,
      formattedEndDate,
      this.productionCycleId ?? 0
    ).subscribe(
      (res: any) => {
        this.salePerProducerReportData = res as any[];
        this.applySortingAndGrouping();
        this.noDataFound =
          !this.salePerProducerReportData ||
          this.salePerProducerReportData.length === 0;
        this.isLoading = false;
      },
      (error) => {
        console.error(error);
        this.noDataFound = true;
        this.isLoading = false;
      }
    );
  }

  applySortingAndGrouping() {
    if (!Array.isArray(this.salePerProducerReportData) || !this.salePerProducerReportData.length) {
      this.groupedSalePerProducerReportData = [];
      return;
    }

    this.salePerProducerReportData.sort((a, b) =>
      (a.producerName || '').localeCompare(b.producerName || '')
    );

    const groups = new Map<string, any[]>();
    this.salePerProducerReportData.forEach((item) => {
      const storeName =
        item.storeName ||
        this.stores.find((str) => str.storeId === item.storeId)?.storeName ||
        'Other Stores';
      const key = storeName;
      if (!groups.has(key)) {
        groups.set(key, []);
      }
      groups.get(key)!.push(item);
    });

    this.groupedSalePerProducerReportData = Array.from(groups.entries())
      .sort((a, b) => a[0].localeCompare(b[0]))
      .map(([storeName, items]) => ({ storeName, items }));
  }

  exportReport() {
    if (!this.salePerProducerReportData || !this.salePerProducerReportData.length) {
      return;
    }

    const exportData = this.salePerProducerReportData.map((item) => ({
      Store:
        item.storeName ||
        this.stores.find((str) => str.storeId === item.storeId)?.storeName ||
        'Other Stores',
      'Producer Name': item.producerName,
      'Quantity Produced': item.quantityProduced,
      'Value Produced': item.totalProductionValue,
      'Quantity Sold': item.totalItemsSold,
      'Total Sales': item.totalSalesAmount
    }));

    exportData.sort((a, b) => a.Store.localeCompare(b.Store));

    this.exportExcelService.exportAsExcelFile(exportData, 'sales-per-producer-report');
  }

  isNumber(value: any): boolean {
    return typeof value === 'number';
  }
}
